'use client'
import React from 'react'

import { InformationIcon } from '@dfds-frontend/navigator-icons/icons'
import { BffInterfacesBasket } from '@dfds-pax/booking-experience-bff'

import { useTranslation } from '@/hooks/useDebugTranslations'

import Price from '../shared/Price'
import Tooltip from '../shared/Tooltip'

interface Props {
  currency: string
  homebound?: BffInterfacesBasket.Departure
  outbound: BffInterfacesBasket.Departure
}

const SurchargeRow: React.FC<Props> = ({ currency, homebound, outbound }: Props) => {
  const surchargePriceOut = outbound?.priceImpactFactors
    ?.filter((p) => p?.type?.toLowerCase() === 'bunkerage')
    ?.reduce((sum, current) => sum + current.adjustment, 0)
  const surchargePriceHome =
    homebound?.priceImpactFactors
      ?.filter((p) => p?.type?.toLowerCase() === 'bunkerage')
      ?.reduce((sum, current) => sum + current.adjustment, 0) ?? 0
  const { t } = useTranslation()

  return (surchargePriceOut && surchargePriceOut > 0) || (surchargePriceHome && surchargePriceHome > 0) ? (
    <div className="border-semantic-global-border-light pt-primitive-16 flex justify-between border-t lg:border-0 lg:pt-0">
      <div className="flex max-w-[280px] flex-row justify-center">
        <div
          className="typography-body-md-regular lg:typography-body-md-regular text-semantic-global-text-default flex items-center"
          data-e2e="booking-summary-ets"
        >
          {t('EMISSIONS-SURCHARGE-TITLE')}
          <Tooltip text={t('EMISSIONS-SURCHARGE-TOOLTIP')}>
            <InformationIcon className="text-semantic-global-primary-default" size="md" />
          </Tooltip>
        </div>
      </div>
      <div className="typography-body-md-regular lg:typography-body-md-regular text-semantic-global-text-default">
        <Price currency={currency} dataAttr="total-surcharge-price" price={surchargePriceOut + surchargePriceHome} />
      </div>
    </div>
  ) : null
}

export default SurchargeRow
